import { SelectOption } from '@web-for-marketing/react-ui';

const americanStateOptions: SelectOption[] = [
    { value: 'AL', content: 'Alabama' },
    { value: 'AK', content: 'Alaska' },
    { value: 'AZ', content: 'Arizona' },
    { value: 'AR', content: 'Arkansas' },
    { value: 'CA', content: 'California' },
    { value: 'CO', content: 'Colorado' },
    { value: 'CT', content: 'Connecticut' },
    { value: 'DE', content: 'Delaware' },
    { value: 'DC', content: 'District of Columbia' },
    { value: 'FL', content: 'Florida' },
    { value: 'GA', content: 'Georgia' },
    { value: 'HI', content: 'Hawaii' },
    { value: 'ID', content: 'Idaho' },
    { value: 'IL', content: 'Illinois' },
    { value: 'IN', content: 'Indiana' },
    { value: 'IA', content: 'Iowa' },
    { value: 'KS', content: 'Kansas' },
    { value: 'KY', content: 'Kentucky' },
    { value: 'LA', content: 'Louisiana' },
    { value: 'ME', content: 'Maine' },
    { value: 'MD', content: 'Maryland' },
    { value: 'MA', content: 'Massachusetts' },
    { value: 'MI', content: 'Michigan' },
    { value: 'MN', content: 'Minnesota' },
    { value: 'MS', content: 'Mississippi' },
    { value: 'MO', content: 'Missouri' },
    { value: 'MT', content: 'Montana' },
    { value: 'NE', content: 'Nebraska' },
    { value: 'NV', content: 'Nevada' },
    { value: 'NH', content: 'New Hampshire' },
    { value: 'NJ', content: 'New Jersey' },
    { value: 'NM', content: 'New Mexico' },
    { value: 'NY', content: 'New York' },
    { value: 'NC', content: 'North Carolina' },
    { value: 'ND', content: 'North Dakota' },
    { value: 'OH', content: 'Ohio' },
    { value: 'OK', content: 'Oklahoma' },
    { value: 'OR', content: 'Oregon' },
    { value: 'PA', content: 'Pennsylvania' },
    { value: 'PR', content: 'Puerto Rico' },
    { value: 'RI', content: 'Rhode Island' },
    { value: 'SC', content: 'South Carolina' },
    { value: 'SD', content: 'South Dakota' },
    { value: 'TN', content: 'Tennessee' },
    { value: 'TX', content: 'Texas' },
    { value: 'UT', content: 'Utah' },
    { value: 'VT', content: 'Vermont' },
    { value: 'VA', content: 'Virginia' },
    { value: 'WA', content: 'Washington' },
    { value: 'WV', content: 'West Virginia' },
    { value: 'WI', content: 'Wisconsin' },
    { value: 'WY', content: 'Wyoming' },
];

export default americanStateOptions;
